

(function(app) {
    app.minheight = (function() {
        var initialized = false;


        var classes = {
            navItem: 'go-href'
        };


        var selectors = {
            header  :  '.page-header',
            entryHeader :  '.entry-header',
            footer: ".page-footer",
            entryContent : '.entry-content'
        };

        var vars = {
            totalHeight : '',
            windowsHeight : ''
        }


        var init = function() {
            initialized = true;
            app.$objs.navItem = $(selectors.navItem);
            bind();
        };


        var bind = function() {
            if(app.windowSize()> 1024) {
                settingContentHeight();
            }
        };

        var width = function() {
            var windowLength = $(window).width();
            return windowLength;
        }


        var findHeight = function () {
            var th,eh,fh;
            th = $(selectors.header).height();
            eh = $(selectors.entryHeader).height();
            fh = $(selectors.footer).height();
            wh = $(window).height();
            
            vars.totalHeight = th + eh + fh;
            vars.windowsHeight = wh;
        }


        var settingContentHeight = function() {
            findHeight();
            var contHeight =   vars.windowsHeight - vars.totalHeight;
            contHeight-=200;
            $(selectors.entryContent).css('min-height' , contHeight + 'px');
        }


        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('minheight');
})(pc);
